<script>
import WhyXiyue from "@/components/WhyXiyue.vue";
import StartRisk from "@/components/StartRisk.vue";

export default {
  name: "CustomBags",
  components: {StartRisk, WhyXiyue}
}
</script>

<template>
  <div align="center">
    <div class="bg-light" style="padding-top: 80px">
      <h1>Custom bags for your needs</h1>
      <b-card-sub-title style="font-size: x-large;max-width: 75%">More than just a carrier, our custom-designed bags are
        the final —
        and most memorable — touchpoint
        of your customer’s journey.
      </b-card-sub-title>
      <b-card class="overflow-hidden border-0 rounded-0 bg-light"
              style="max-width: 75%;padding-top: 80px;padding-bottom: 80px">
        <b-row no-gutters align-v="center">
          <b-col md="9">
            <b-card-body style="margin-right: 20px">
              <h2>Paper Mailing Envelopes</h2>
              <b-card-text class="text-left" style="font-size: x-large;padding-top: 20px">
                Secure & professional shipping solutions. Lightweight yet durable, designed for safe delivery and clean
                brand presentation across all e-commerce and business needs.
              </b-card-text>
            </b-card-body>
          </b-col>
          <b-col md="3">
            <b-card-img-lazy src="@/assets/10-1.jpg"></b-card-img-lazy>
          </b-col>
        </b-row>
      </b-card>
    </div>

    <b-card class="overflow-hidden border-0 rounded-0" style="padding-top: 80px;max-width: 75%;padding-bottom: 80px">
      <b-row no-gutters align-v="center">
        <b-col md="3">
          <b-card-img-lazy src="@/assets/10-2.jpg"></b-card-img-lazy>
        </b-col>
        <b-col md="9">
          <b-card-body style="margin-left: 20px">
            <h2>Premium Gift & Shopping Bags</h2>
            <b-card-text class="text-left" style="font-size: x-large;padding-top: 20px">
              Unbox the experience. Luxury paper stocks, custom finishes, and lasting handles turn every bag into a
              mobile
              billboard of your brand’s prestige.
            </b-card-text>
          </b-card-body>
        </b-col>
      </b-row>
    </b-card>
    <div class="bg-light" style="padding-top: 80px;padding-bottom: 80px">
      <b-card class="overflow-hidden border-0 rounded-0 bg-light" style="max-width: 75%">
        <b-row no-gutters align-v="center">
          <b-col md="9">
            <b-card-body style="margin-right: 20px">
              <h2>Freshness-Lock Barrier Bags</h2>
              <b-card-text class="text-left" style="font-size: x-large;padding-top: 20px">
                Seal in flavor, seal out air. Airtight, resealable, and barrier-lined for maximum freshness—ideal for
                coffee, tea, snacks, and perishables.
              </b-card-text>
            </b-card-body>
          </b-col>
          <b-col md="3">
            <b-card-img-lazy src="@/assets/10-3.jpg"></b-card-img-lazy>
          </b-col>
        </b-row>
      </b-card>
    </div>
    <b-card class="overflow-hidden border-0 rounded-0" style="padding-top: 80px;max-width: 75%;padding-bottom: 80px">
      <b-row no-gutters align-v="center">
        <b-col md="3">
          <b-card-img-lazy src="@/assets/10-4.jpg"></b-card-img-lazy>
        </b-col>
        <b-col md="9">
          <b-card-body style="margin-left: 20px">
            <h2>Reusable Fabric Pouches, Tote Bags</h2>
            <b-card-text class="text-left" style="font-size: x-large;padding-top: 20px">
              Carry your values. Durable, washable, and eco-conscious, these bags transform customers into brand
              ambassadors with every reuse.
            </b-card-text>
          </b-card-body>
        </b-col>
      </b-row>
    </b-card>

    <div style="padding-top: 120px;padding-bottom: 80px">
      <h1>Beyond Green: Our Material Promise</h1>
      <b-card no-body class="overflow-hidden border-0 rounded-0" style="max-width: 75%;padding-top: 80px">
        <b-row no-gutters class="text-left" align-v="center">

          <b-col md="8" class="align-middle">
            <b-card-body class="text-left" style="font-size: x-large;margin-right: 20px">
              <b-card-text>
                For brands that lead with purpose, packaging is your most powerful physical touchpoint. We craft it from
                a foundation of verified sustainability—using premium recycled and FSC-certified materials that perform
                without compromise.
              </b-card-text>
              <b-card-text>
                For brands that lead with purpose, packaging is your most powerful physical touchpoint. We craft it from
                a foundation of verified sustainability—using premium recycled and FSC-certified materials that perform
                without compromise.
              </b-card-text>
              <b-card-text>
                This is more than packaging. It’s your environmental statement, materialized. Let’s build the box that
                builds your future.
              </b-card-text>
            </b-card-body>
          </b-col>
          <b-col md="4">
            <b-card-img src="@/assets/10-5.jpg" alt="Image"></b-card-img>
          </b-col>
        </b-row>
      </b-card>
    </div>
    <div class="bg-light" style="padding-top: 80px;padding-bottom: 80px">
      <WhyXiyue></WhyXiyue>
    </div>
    <div style="padding-bottom: 80px;padding-top: 80px;max-width: 75%;">
      <StartRisk></StartRisk>
    </div>
  </div>


</template>

<style scoped lang="scss">

</style>